import React, { Component } from 'react';
import moment from 'moment-business-days';
import Calendar from 'react-calendar';
import {
	Button,
	ControlLabel,
	FormControl,
	FormGroup
} from 'react-bootstrap';

import './RequestForm.css';

import { makeRequest } from '../../utils/makeRequests';

export default class RequestForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			start: null,
			hoursReq: 0,
			today: new Date()
		}

		this.calculateLimit = this.calculateLimit.bind(this);
		this.calculatePTO = this.calculatePTO.bind(this);
		this.determineMinDate = this.determineMinDate.bind(this);
		this.submitRequest = this.submitRequest.bind(this);
	}

	calculatePTO(range) {
		const [start, end] = range;
		this.setState({ hoursReq: (moment(start).businessDiff(moment(end)) * 8), start: null, dateRequested: start });
	}

	calculateLimit(date) {
		const { start } = this.state;

		if (!start) {
			this.setState({ start: date, hoursReq: 0 });
			return;
		}

		return;
	}

	determineMaxDate() {
		const { start } = this.state;

		if (start) {
			return moment(start).add(13, 'days').toDate();
		}

		return;
	}

	determineMinDate() {
		const { start, today } = this.state;

		if (!start) {
			return today;
		}

		if (moment(start).subtract(2, 'weeks').isBefore(today)) {
			return today;
		}

		return moment(start).subtract(13, 'days').toDate();
	}

	submitRequest(e) {
		e.preventDefault();

		const { dateRequested, hoursReq } = this.state;
		const { employeeId, addRequest, closeForm } = this.props;

		makeRequest(employeeId, moment(dateRequested).format('YYYY-MM-DD'), hoursReq)
		 	.then(resp => {
		 		addRequest(resp);
		 		closeForm();
		 	});
	}

	getValidationState() {
		const { hoursReq } = this.state;

		if (hoursReq < 8) {
			return 'error';
		}

		return 'success';
	}

	render() {
		return <form onSubmit={this.submitRequest}>
			<FormGroup
				style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
				validationState={this.getValidationState()}
			>
				<Calendar calendarType='US' activeStartDate={this.state.today} selectRange onChange={this.calculatePTO} onClickDay={this.calculateLimit} minDate={this.determineMinDate()} maxDate={this.determineMaxDate()} />
				<FormControl.Static style={{fontSize: 50}}>{this.state.hoursReq}</FormControl.Static>
				<ControlLabel>hours</ControlLabel>
			</FormGroup>
			<Button style={{color: 'white', background: '#15A251FF'}} block bsSize="lg" type="submit" disabled={this.state.hoursReq < 8}>Submit</Button>
		</form>
	}
}


// WEBPACK FOOTER //
// ./src/components/Request/RequestForm.js